import { useCallback, useState } from "react";
import { useFeatureFlagToken } from "../../hooks/useFeatureFlag";
import { FeatureFlagName } from "../../types/feature-flags/featureFlag";

const STORAGE_KEY = "cr-ui-preference";

export type UiPreference = "v1" | "v2" | null;

export interface UseUiPreferenceResult {
  preference: UiPreference;
  setPreference: (value: "v1" | "v2") => void;
  isEligible: boolean;
  effectiveUi: "v1" | "v2";
}

function readStored(): UiPreference {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === "v1" || v === "v2" ? v : null;
  } catch {
    return null;
  }
}

export function useUiPreference(): UseUiPreferenceResult {
  const isEligible = useFeatureFlagToken(FeatureFlagName.V2UI);
  const [preference, setPreferenceState] = useState<UiPreference>(readStored);

  const setPreference = useCallback((value: "v1" | "v2") => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {
      /* ignore storage errors */
    }
    setPreferenceState(value);
  }, []);

  const effectiveUi: "v1" | "v2" = !isEligible
    ? "v1"
    : preference === "v1"
      ? "v1"
      : "v2";

  return { preference, setPreference, isEligible, effectiveUi };
}
